import { cn } from '@/lib/utils';

type AlertDialogFooterProps = React.ComponentProps<'div'>;

export const AlertDialogFooter = ({
  className,
  ...props
}: AlertDialogFooterProps) => (
  <div
    data-slot="alert-dialog-footer"
    className={cn(
      'tw-bg-muted/50 -tw-mx-4 -tw-mb-4 tw-rounded-b-xl tw-border-t tw-p-4 tw-flex tw-flex-col-reverse tw-gap-2 group-data-[size=sm]/alert-dialog-content:tw-grid group-data-[size=sm]/alert-dialog-content:tw-grid-cols-2 sm:tw-flex-row sm:tw-justify-end',
      className,
    )}
    {...props}
  />
);
